import { useEffect, useRef } from "react";

export function useDebouncedAsyncEffect(callback, deps, delay) {
  const timeoutRef = useRef();

  useEffect(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = setTimeout(() => {
      callback();
    }, delay);

    return () => {
      clearTimeout(timeoutRef.current);
    };
  }, [...deps, delay]);
}
